export const GET_CLIENTS_INFO_START = 'GET_CLIENTS_INFO_START';
export const GET_CLIENTS_INFO_SUCCESS = 'GET_CLIENTS_INFO_SUCCESS';
export const GET_CLIENTS_INFO_FAILURE = 'GET_CLIENTS_INFO_FAILURE';